/**************************************************
 * Nombre:       Formulario_Productos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     1 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import {FlagOutlined, Layers, LocalOffer} from "@mui/icons-material";
import IngresoTexto from "../../Modulo_formularios/Componentes/IngresoTexto";
import {CATEGORIAS, ESTADOSPRENDA} from "../../Constantes";
import IngresoImagenCrop from "../../Modulo_formularios/Componentes/IngresoImagenCrop";
import {useEffect, useState} from "react";
import {obtenerCol} from "../../Servicios/BD/obtenerCol";
import IngresoSelectPropId from "../../Modulo_formularios/Componentes/IngresoSelectPropId";
import IngresoSelect from "../../Modulo_formularios/Componentes/IngresoSelect";
import IngresoDinero from "../../Modulo_formularios/Componentes/IngresoDinero";
import IngresoPdf from "../../Modulo_formularios/Componentes/IngresoPdf";
import IngresoSelectFuncion from "../../Modulo_formularios/Componentes/IngresoSelectFuncion";


const Formulario_Producto = ({...props}) => {
    const [colecciones, setColecciones] = useState([])
    const [tipos, setTipos] = useState([])
    const [ver, setVer] = useState(false)

    useEffect(() => {

        obtenerCol('colecciones').then((dox) => {
            setColecciones(dox.data)
        })

        obtenerCol('subcategorias').then((dox) => {
            setTipos(dox.data)
        })

    }, [])

    return (
        <form noValidate style={{width: '100%'}}>
            <Grid
                container
                justifyContent={'flex-start'}
                alignItems={'center'}
                size={{xs: 12, sm: 12, md: 12}}
                spacing={2}
            >


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Estado y Coleccion</Typography>
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Estado'}
                                   dato={'estado'}  {...props}
                                   opciones={ESTADOSPRENDA.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={{xs: 6, sm: 6, md: 6}}>
                    <IngresoSelectPropId Icono={Layers} nombre={'Coleccion'} propiedad={'nombre'} propiedadId={'id'}
                                         dato={'coleccion'} datoId={'idColeccion'}{...props}
                                         opciones={colecciones}
                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Imagen de la prenda con fondo blanco</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoImagenCrop alto={2} ancho={2}
                                       dato={'img'} {...props}

                    />
                </Grid>


                <Grid container size={6}>
                    <IngresoSelect Icono={Layers} nombre={'Categoria'}
                                   dato={'categoria'} {...props} opciones={CATEGORIAS.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoSelect Icono={FlagOutlined} nombre={'Tipo'}
                                   dato={'tipo'} {...props} opciones={tipos.map((it) => it.nombre)}
                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero nombre={'Valor'}
                                   dato={'valor'} {...props}

                    />
                </Grid>

                <Grid container size={6}>
                    <IngresoDinero Icono={LocalOffer} nombre={'Valor Rebajado'}
                                   dato={'rebajado'} {...props}

                    />
                </Grid>


                <Grid container size={{xs: 12, sm: 12, md: 12}}>
                    <Typography sx={{fontSize: 14}}>Detalles del producto</Typography>
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto Icono={Layers} nombre={'Nombre de la prenda'}
                                  dato={'nombre'} {...props}

                    />
                </Grid>

                <Grid container size={12}>
                    <IngresoTexto lineas={5} nombre={'Descripcion de la prenda'}
                                  dato={'descripcion'} {...props}

                    />
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <Typography sx={{fontSize: 14}}>Contiene guia de tallas</Typography>
                </Grid>

                <Grid container size={{xs: 12, sm: 12, md: 6}}>
                    <IngresoSelectFuncion nombre={'Guia de Tallas'} dato={'guia_tallas'}  {...props} setDato={setVer}
                                          opciones={['Si', 'No']}
                    />
                </Grid>

                {ver === 'Si' &&

                    <Grid container size={{xs: 12, sm: 12, md: 12}}>
                        <IngresoPdf dato={'pdf'}  {...props} setDato={setVer}/>
                    </Grid>

                }


            </Grid>

        </form>

    )

}
export default Formulario_Producto